import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { blogList } from "../../Details";

function BlogIndex() {
   // 添加状态来跟踪当前选中的 topic
   const [selectedTopic, setSelectedTopic] = useState("");

   // 从博客列表中提取所有唯一的 topic 值
   const allTopics = useMemo(() => {
      const topics = blogList.map((blog) => blog.topic).filter(Boolean);
      return [...new Set(topics)]; // 去重
   }, []);

   // 根据选中的 topic 筛选博客文章
   const filteredBlogs = useMemo(() => {
      if (!selectedTopic) return blogList; // 如果没有选择 topic，显示所有文章
      return blogList.filter((blog) => blog.topic === selectedTopic);
   }, [selectedTopic]);

   return (
      <main className="container mx-auto max-width pt-10 mb-20 min-h-screen">
         <section>
            <div className="flex flex-col md:flex-row justify-between items-baseline mb-8">
               <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-3xl xl:text-4xl font-bold">
                  Blog Posts
               </h1>
            </div>

            {/* 添加 topic 筛选按钮 */}
            <div className="flex flex-wrap gap-2 mb-6">
               <button
                  onClick={() => setSelectedTopic("")}
                  className={`px-3 py-1 text-sm rounded-full transition-colors ${
                     !selectedTopic
                        ? "bg-blue-600 text-white dark:bg-blue-500"
                        : "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
                  }`}
               >
                  All Topics
               </button>
               {allTopics.map((topic) => (
                  <button
                     key={topic}
                     onClick={() => setSelectedTopic(topic)}
                     className={`px-3 py-1 text-sm rounded-full transition-colors ${
                        selectedTopic === topic
                           ? "bg-blue-600 text-white dark:bg-blue-500"
                           : "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
                     }`}
                  >
                     {topic}
                  </button>
               ))}
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
               {React.Children.toArray(
                  filteredBlogs.map(({ title, topic, description, slug, date }) => (
                     <article className="group flex flex-col h-full bg-white dark:bg-dark-card rounded-lg overflow-hidden transition-all duration-300 hover:shadow-md border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600">
                        <Link to={`/blog/${slug}`} className="block flex-grow p-6">
                           <div className="flex items-center mb-3 text-xs text-gray-500 dark:text-gray-400">
                              {topic && (
                                 <span className="inline-block bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full px-2 py-1 mr-2">
                                    {topic}
                                 </span>
                              )}
                              <time dateTime={date}>{date}</time>
                           </div>

                           <h2 className="text-xl font-semibold text-dark-heading dark:text-light-heading mb-3 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                              {title}
                           </h2>

                           <p className="text-dark-content dark:text-light-content text-sm mb-4 line-clamp-3">
                              {description}
                           </p>

                           <div className="mt-auto text-sm font-medium text-blue-600 dark:text-blue-400 group-hover:underline">
                              Read
                              <span className="ml-1 group-hover:ml-2 transition-all duration-200">→</span>
                           </div>
                        </Link>
                     </article>
                  ))
               )}
            </div>

            {filteredBlogs.length === 0 && (
               <div className="text-center py-12">
                  <p className="text-dark-content dark:text-light-content">暂无博客文章</p>
               </div>
            )}
         </section>
      </main>
   );
}

export default BlogIndex;
